import { __, _x, sprintf } from "@wordpress/i18n";
import { useEffect, useState } from "@wordpress/element";

import Downshift from "downshift";
import { useSearchStores } from "../../../../manitoba-stores/react/services/search.js";

export function StoreAutocomplete({
  value,
  onInput,
  onChange,
  preload = false,
  storeSearchRequest,
  ...props
}) {
  const [search, setSearch] = useState();
  const [initialStore, setInitialStore] = useState(
    value && value.id && value.name ? value : null
  );
  const [{ data: storesFound, loading, error }, searchStore] =
    useSearchStores();

  useEffect(
    function () {
      setSearch(storeSearchRequest);
    },
    [storeSearchRequest]
  );

  useEffect(
    function () {
      if (!search && !preload) return;
      searchStore(search);
    },
    [value, preload, search]
  );

  useEffect(
    function () {
      // On recherche le store pré-sélectionné, si pas de recherche en cours
      if (!value || !value.id || value.name) return;
      if (search) return;
      setSearch(`store:${value.id}`);
    },
    [value, search]
  );

  useEffect(
    function () {
      // On définit le store initial selon le résultat de la recherche
      if (!value || !value.id || value.name) return;
      if (!search || search !== `store:${value.id}`) return;
      const storeFound =
        storesFound && storesFound.length === 1 ? storesFound[0] : null;
      setInitialStore(storeFound);
      onChange && onChange(storeFound);
      setSearch("");
    },
    [storesFound, search, value]
  );

  const isOnlyStoreAlreadySelected =
    value &&
    storesFound &&
    storesFound.length === 1 &&
    storesFound[0].id === value.id;

  // if (value && !initialStore) {
  //   if (loading) {
  //     return (
  //       <p className="loading">
  //         <span className="loading-message">
  //           {__("Chargement de l'agence...", "Frontend form", "manitoba-leads")}
  //         </span>
  //       </p>
  //     );
  //   }
  // }

  return (
    <Downshift
      onChange={onChange}
      initialSelectedItem={initialStore}
      initialInputValue={initialStore ? initialStore.name : ""}
      itemToString={(store) => (store ? store.name : "")}
      getItemId={(store) => (store ? store.id : "")}
      onInputValueChange={(value) => setSearch(value || storeSearchRequest)}
    >
      {({
        getInputProps,
        getItemProps,
        getMenuProps,
        isOpen,
        selectedItem,
        getRootProps,
      }) => (
        <div
          className={`store-autocomplete${
            loading ? ` store-autocomplete--loading` : ""
          }${
            !storesFound || !storesFound.length
              ? ` store-autocomplete--empty`
              : ""
          }${
            isOpen || storeSearchRequest === search
              ? ` store-autocomplete--open`
              : ""
          }`}
        >
          <div
            {...getRootProps({}, { suppressRefError: true })}
            className="store-autocomplete-input-container"
          >
            <input
              {...getInputProps()}
              className="store-autocomplete-input"
              {...props}
            />
          </div>
          {!!error && <p className="store-autocomplete-error">{error}</p>}
          {!!loading ? (
            <span className="store-autocomplete-loading">
              {_x("Chargement...", "Frontend form", "manitoba-leads")}
            </span>
          ) : !storesFound || !storesFound.length ? (
            <span className="store-autocomplete-empty">
              {_x("Aucun résultat", "Frontend form", "manitoba-leads")}
            </span>
          ) : (
            (isOpen || !initialStore) &&
            !isOnlyStoreAlreadySelected && (
              <ul {...getMenuProps()} className="store-autocomplete-options">
                {(storesFound || []).map((store, index) => (
                  <li
                    {...getItemProps({
                      key: store.id,
                      index,
                      item: store,
                    })}
                    className={`store store-autocomplete-option${
                      selectedItem && selectedItem.id === store.id
                        ? ` store-autocomplete-option--active`
                        : ""
                    }`}
                  >
                    <StoreOption {...store} />
                  </li>
                ))}
              </ul>
            )
          )}
        </div>
      )}
    </Downshift>
  );
}

export default function StoreOption({
  name,
  distance,
  street,
  postalcode,
  city,
}) {
  const address = sprintf(
    _x("%s, %s %s", "Adresse, avec rue, code postal, ville", "manitoba-stores"),
    street,
    postalcode,
    city
  );

  return (
    <div className={"store"}>
      <h4 className="store-name">
        {name}
        {!!distance && (
          <span className="store-distance">
            {sprintf(__(" - %d km", "manitoba-stores"), Math.round(distance))}
          </span>
        )}
      </h4>
      <p className="store-address">{address}</p>
    </div>
  );
}
